import { get, patch, post, destroy } from './httpClient'

export const getCategories = (params) => get('/category', params)
export const addCategory = (body) => post('/category/create', body)
export const updateCategory = (body, id) => patch(`/category/update/${id}`, body)
export const bulkUpdateCategory = (body) => patch(`/category/bulk-update`, body)
export const deleteCategory = (ids) => destroy('/category/delete', { category_id: ids })
